import { render, staticRenderFns } from "./SettingsCard.vue?vue&type=template&id=fcdb1734&scoped=true"
import script from "./SettingsCard.vue?vue&type=script&lang=js"
export * from "./SettingsCard.vue?vue&type=script&lang=js"
import style0 from "./SettingsCard.vue?vue&type=style&index=0&id=fcdb1734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdb1734",
  null
  
)

export default component.exports